import React from "react";

interface PaginationButtonProps {
  label: string;
  isSelected: boolean;
  onClick: () => void;
}

const PaginationButton = ({
  label,
  isSelected,
  onClick,
}: PaginationButtonProps) => (
  <div
    onClick={onClick}
    className={`py-2 px-3  rounded-md cursor-pointer
      ${isSelected ? 'bg-ptTeal text-white' : 'bg-gray-200 hover:bg-gray-300'}
    `}
  >
    {label}
  </div>
)

export default PaginationButton